import React, { useContext, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AppStateContext, AppDispatchContext } from '../../context/AppContext';
import { StyledNavIcon, AccentButton } from '../../styles/common';

const GoBackButton = ({ onClick, path }) => {
    const { goBackLink } = useContext(AppStateContext);
    const returnPath = goBackLink || path;
    const dispatch = useContext(AppDispatchContext);
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleClick = useCallback(() => {
        if (onClick) onClick();
        dispatch({ type: 'SET_GO_BACK_LINK', payload: '' });
        navigate(returnPath);
    }, [onClick, dispatch, navigate, returnPath]);

    useEffect(() => {
        const handleEnter = (e) => {
            if (e.keyCode === 13) {
                handleClick();
            }
        };
        document.addEventListener('keyup', handleEnter);
        return () => {
            document.removeEventListener('keyup', handleEnter);
        };
    }, [handleClick]);

    return (
        <AccentButton outline size="sm" onClick={handleClick}>
            <StyledNavIcon icon="check" />
            {t('terminusCardLabels$stateless$button')}
        </AccentButton>
    );
};

export default GoBackButton;
